const pad = (value) => String(value).padStart(2, "0");

const formatDate = (date) =>
  `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())}`;

const formatDateValue = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const getIsoWeekNumber = (date) => {
  const utcDate = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
  );
  const day = utcDate.getUTCDay() || 7;

  utcDate.setUTCDate(utcDate.getUTCDate() + 4 - day);
  const yearStart = new Date(Date.UTC(utcDate.getUTCFullYear(), 0, 1));

  return Math.ceil(((utcDate - yearStart) / 86400000 + 1) / 7);
};

export const getSummaryReportRangeOptions = (items = []) =>
  items.map((item) => {
    const weekStart = new Date(`${item.weekStart}T00:00:00`);
    const weekEnd = new Date(`${item.weekEnd}T23:59:59`);
    const isPartial = Boolean(
      item.siteCreatedAt &&
      item.weekStart <= item.siteCreatedAt &&
      item.siteCreatedAt <= item.weekEnd,
    );

    return {
      value: item.summaryReportId,
      summaryReportId: item.summaryReportId,
      weekStart: item.weekStart,
      weekEnd: item.weekEnd,
      timezone: item.timezone,
      generatedAt: item.generatedAt,
      siteCreatedAt: item.siteCreatedAt,
      isPartial,
      label: `${formatDate(weekStart)} - ${formatDate(weekEnd)} (W${pad(getIsoWeekNumber(weekStart))})`,
    };
  });

/**
 * Returns the last complete Monday-to-Sunday week and the 51 weeks before it.
 */
export const getPreviousYearWeeklyRanges = (referenceDate = new Date()) => {
  const currentMonday = new Date(referenceDate);
  currentMonday.setHours(0, 0, 0, 0);
  currentMonday.setDate(
    currentMonday.getDate() - ((currentMonday.getDay() + 6) % 7),
  );

  const lastWeekMonday = new Date(currentMonday);
  lastWeekMonday.setDate(lastWeekMonday.getDate() - 7);

  return Array.from({ length: 52 }, (_, index) => {
    const start = new Date(lastWeekMonday);
    start.setDate(start.getDate() - index * 7);

    const end = new Date(start);
    end.setDate(end.getDate() + 6);

    const endOfWeek = new Date(end);
    endOfWeek.setHours(23, 59, 59, 999);

    const weekNumber = pad(getIsoWeekNumber(start));
    const label = `${formatDate(start)} - ${formatDate(end)} (W${weekNumber})`;

    return {
      value: formatDateValue(start),
      label,
      startDate: start,
      endDate: end,
      from: Math.floor(start.getTime() / 1000),
      to: Math.floor(endOfWeek.getTime() / 1000),
    };
  });
};
